import React from 'react';
import styled from 'styled-components';

import { colors } from 'lib/prisma-styles';

import { ConfirmationModal } from '../ConfirmationModal';

import { RemoveModalProps } from './types';

const REMOVE_MODAL_SUBMIT_BUTTON_CLASS_NAME = 'remove-modal__submit-button';

const StyledConfirmationModal = styled(ConfirmationModal)`
  & {
    .${REMOVE_MODAL_SUBMIT_BUTTON_CLASS_NAME} {
      background-color: ${colors.interactive.destructiveAction};
    }
  }
`;

const RemoveModal = ({
  children,
  ...modalProps
}: RemoveModalProps) => (
  <StyledConfirmationModal
    isFullscreenMode={false}
    submitButtonClassName={REMOVE_MODAL_SUBMIT_BUTTON_CLASS_NAME}
    {...modalProps}
  >
    {children}
  </StyledConfirmationModal>
);

export { RemoveModal };
